"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconEnvironmentalConstruction = function IconEnvironmentalConstruction(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M37.23 5a4 4 0 0 0-2.935 1.282L21.383 18.28 18.173 9H7v21h3v1.008a5.42 5.42 0 0 0-3.3 1.466A5.42 5.42 0 0 0 5 36.36C5 39.48 7.52 42 10.63 42h16.91a5.63 5.63 0 0 0 5.63-5.63A5.42 5.42 0 0 0 28 31v-1h3V19h-7.454l9.787-9.094a4 4 0 0 0 1.252 2.095l-3.292 3.292 1.414 1.414 3.252-3.252 4.444 12.274-7.44 2.785.35.936c1.623 4.343 5.958 6.796 9.758 5.42 3.79-1.373 5.447-6.121 3.82-10.49L41.15 8.207A4 4 0 0 0 37.23 5m5.046 20.028 2.403-.9-4.435-12.498a4 4 0 0 1-2.343 1.314zM39.21 8.717l-.264-.746a2 2 0 0 0-3.16-.354l.005.006-.07.065a2 2 0 1 0 3.49 1.03M12 30h14v1.001H12zm0 3h15.886c.843.04 1.617.366 2.212.928a3.42 3.42 0 0 1 1.072 2.452A3.63 3.63 0 0 1 27.54 40H10.63A3.63 3.63 0 0 1 7 36.37 3.42 3.42 0 0 1 10.236 33zm4.747-22 2.769 8H13v-8zM9 11h2v10h18v7H9zm36.357 15.259-.052-.23-9.71 3.635c1.429 2.715 4.206 4.133 6.601 3.39l.193-.064c2.348-.85 3.588-3.726 2.968-6.731M10 36.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m2 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0m4.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m0 1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m3.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m2 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0m4.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m0 1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1",
    clipRule: "evenodd"
  })));
};

export { IconEnvironmentalConstruction, IconEnvironmentalConstruction as default };
